<!--
component: MapPane
author: Ken Nakamura
description: 地図検索画面
-->
<template>
  <body>
    <section class="map-pane">
    DEV202307-44 検索条件入力画面：閲覧モード検索条件入力
    
    <br/>
    
    <container>
      <div class="section">
        <div>
          <button @click="toggleButton(0)" class="win95-button" :class="{ 'pressed': isPressed[0] }">1. 一般・区画区分</button>
        </div>

        <div class="custom-select">
          <select v-model="selectedOption" :disabled="!isPressed[0]">
            <option value="option1">AAA</option>
            <option value="option2">BBB</option>
            <option value="option3">CCC</option>
          </select>
        </div>
      </div>

      <!-- 2. 年度 -->
      <div class="section">
        <div>
          <button @click="toggleButton(1)" class="win95-button" :class="{ 'pressed': isPressed[1] }">2. 年度</button>
        </div>

        <div class="custom-select">
          <select v-model="selectedOption" :disabled="!isPressed[1]">
            <option value="option1">明治</option>
            <option value="option2">大正</option>
            <option value="option3">昭和</option>
            <option value="option3">平成</option>
            <option value="option3">令和</option>
          </select>
        </div>
        
        <div>
          <input class="textbox" type="text" id="textInput"  :disabled="!isPressed[1]" style="width: 100px;" placeholder="年">
        </div>
        <div>年度</div>
      </div>
    
    <!-- 3. 区 4. 番号 横並び-->
    <div class="flex-container">
      <!-- 3. 区 -->
      <div class="section">
        <div>
          <button @click="toggleButton(2)" class="win95-button" :class="{ 'pressed': isPressed[2] }">3. 区</button>
        </div>

        <div class="custom-select">
          <select v-model="selectedOption" :disabled="!isPressed[2]">
            <option value="option1">オプション1</option>
            <option value="option2">オプション2</option>
            <option value="option3">オプション3</option>
          </select>
        </div>
      </div>

      <!-- 4. 番号 -->
      <div class="section">
        <div>
          <button @click="toggleButton(3)" class="win95-button" :class="{ 'pressed': isPressed[3] }">4. 番号</button>
        </div>
        
        <div>
          <input class="textbox" type="text" id="textInput"  :disabled="!isPressed[3]" style="width: 100px;" placeholder="">
        </div>  
      </div>
    </div>
  </container>

  <!-- ボタン -->
  <div class="button-container">
        <button class="action-button" @click="search">検索</button>
        <button class="action-button">条件クリア</button>
        <button class="action-button">キャンセル</button>
      </div>
      <Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
        title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
    </section>
  </body>
</template>

<script>
//import MapComponent from '../components/Map.vue'
import { apiUrl, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt } from '../common/utils'
import constants from '../common/constants'
import { callGetApi } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'

export default {
  data () {
    return {
      isPressed: [false, false, false, false, false, false, false, false, false],
      isCheckedBox: [false, false, false, false, false, false],
      scalevisible: false,
      existsGaiyo: false,
      plotUrl: '',
      plotUrlAlt: '',
      plotDef: null,
      plotDefAlt: null,
      sheetUrl: '',
      nendoList: [],
      bgmapList: [],
      queryingSheet: false,
      nendoCols: 12,
      nendoXlCols: 6,
      textClass: 'text-h6',
      targetPlotData: this.targetPlot,
      selectedLayer: '',
      // swipe用変数
      position: 0,
      startX: 0,
      moveX: 0,
      width: 0,
      authDialog: false,
    }
  },
  components: {
//    MapComponent,
    Dialog,
  },

  props: {
    zoom: {
      type: Number,
      default: 18,
    },
    targetPlot: {
      type: Object,
      default: null,
    },
  },
  created () {
    this.plotUrl = plotUrl();
    this.plotUrlAlt = plotUrlAlt();
    this.plotDef = constants.tileDef[this.mode];
    if (this.mode == 5) {
      this.plotDefAlt = constants.tileDef[6];
    }
    dbglog('MapPane:' + this.plotDef);
    if (this.sheetVisible) {
      if (this.mode == 1) {
        this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[8].url;
      }
      else if (this.mode == 5) {
        this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[9].url;
      }
    }
    if (this.mode == 7) {
      ///*
      this.bgmapList = [
        this.$store.state.mapOrigin + constants.tileDef[10].url,
        this.$store.state.mapOrigin + constants.tileDef[11].url,
      ];
      //*/
      /*
      this.bgmapList = [];
      if (this.$store.state.seibiSokushinVisible) {
        this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[10].url);
      }
      if (this.$store.state.douroShubetsuVisible) {
        this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[11].url);
      }
      */
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 5);
    this.setMessage();
    //選択されているプロットの番号が保存されている場合
    if (this.selectedNo) {
      this.searchGaiyo(this.selectedNo, (data) => {
        this.existsGaiyo = (data && data.length);
      });
    }
    //this.targetPlotData = this.targetPlot; //ここでは遅い
    //test
    //console.log(this.targetPlot);
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val); }
    },
    browsable () {
      return this.isSelected && this.existsGaiyo;
    },
    features: {
      get() { return this.$store.state.features; },
      set(val) { this.$store.commit('setFeatures',val); }
    },
    sheets: {
      get() { return this.$store.state.sheets; }
    },
    mode () {
      return this.$store.state.mode;
    },
    authority () {
      //return this.$store.state.authority;
      return this.$store.state.userInfo.authority;
    },
    sheetVisible () {
      //return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
      // authority=4 は住所検索と番号検索のみ（仮）
      return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
    },
    douroShubetsuVisible: {
      get() {
        return this.$store.state.douroShubetsuVisible;
      },
      set(val) {
        this.$router.commit('setDouroShubetsuVisible', val);
      }
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    selectedNo: {
      get() { return this.$store.state.selectedNo; },
      set(val) { this.$store.commit('setSelectedNo', val); }
    },
    selectedId: {
      get() { return this.$store.state.selectedId; },
      set(val) { this.$store.commit('setSelectedId', val); }
    },
    gaiyoList() {
      return this.$store.state.gaiyoList;
    },
    centerx() {
      return this.$store.state.centerx;
    },
    centery() {
      return this.$store.state.centery;
    },
    selectedPlotTitle() {
      let title = this.plotDef.title;
      if (this.plotDefAlt)
        title += '・' + this.plotDefAlt.title;
      return title;
    },
    browseButtonTitle() {
      if (this.mode == 1) {
        return '概要書を閲覧';
      }
      else if (this.mode == 2) {
        return '昇降機台帳を閲覧';
      }
      else if (this.mode == 3) {
        return '定期報告概要書を閲覧';
      }
      else if (this.mode == 5) {
        if (this.selectedLayer == 'vectorLayer')
          return '開発登録簿を閲覧';
        else if (this.selectedLayer == 'vectorLayerAlt')
          return '造成計画平面図を閲覧';
        else
          return '閲覧';
      }
      else {
        return '閲覧';
      }
    },
    isSelected() {
      return this.selectedNo !== undefined && this.selectedNo !== null
          && this.selectedNo != '';
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    oyaban() {
      return this.$store.state.oyaban;
    },
    edaban() {
      return this.$store.state.edaban;
    },
    bottomSheet() {
      return ((this.$store.state.features.length > 0) && (this.$vuetify.breakpoint.name == 'xs'));
    }
  },
  watch: {
    features (newValue, oldValue) {
      dbglog(`MapPane: watch.features(${newValue},${oldValue})`, 2);
      if (newValue != null) {
        if (newValue.length == 0 || newValue.length > 1) {
          this.selectedId = '';
          this.selectedNo = '';
          this.selectedLayer = '';
        }
        else if (newValue.length == 1) {
          this.selectRow(newValue[0]);
        }
      }
    },
    sheets (newValue, oldValue) {
      if ((newValue != oldValue) && !this.queryingSheet) {
        const ku = this.wardCode - 14100;
        let sheets = '';
        for (let i = 0; i < newValue.length; i++) {
          sheets += (sheets.length > 0 ? ',' : '') + newValue[i].indexId;
        }
        let url = '';
        if (this.mode == 1) {
          url = apiUrl('KenkakuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
        }
        else if (this.mode == 5) {
          url = apiUrl('KaihatsuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
        }
        else {
          return;
        }
        this.queryingSheet = true;
        callGetApi(url, (data) => {
          this.nendoList = [];
          if (data.length) {
            if (data.length > 10) {
              this.nendoCols = 6;
              this.nendoXlCols = 4;
              this.textClass = 'text-h7';
            }
            else {
              this.nendoCols = 12;
              this.nendoXlCols = 6;
              this.textClass = 'text-h6';
            }
            for (let i = 0; i < data.length; i++) {
              for (let j = 0; j < newValue.length; j++) {
                if (data[i].id == newValue[j].indexId) {
                  this.nendoList.push({
                    id: data[i].id,
                    name: data[i].name,
                    pageNo: newValue[j].pageNo,
                    branch: newValue[j].branch
                  });
                  break;
                }
              }
            }
          }
          this.queryingSheet = false;
        });
      }
    },
  },
  methods: {
    search() {
    }, 
    plotKey(layerFeature) {
      const k = layerFeature.feature ?? layerFeature;
      let result = k.get(this.plotDef.key);
      if (this.plotDefAlt !== null) {
        //if (result === undefined || result === null || result.length === undefined || result.length == 0) {
        if (!result) {
          result = k.get(this.plotDefAlt.key);
        }
      }
      return result;
    },
    isSelectedRow(k) {
      //const layer = k.layer;
      const feature = k.feature;
      const no = this.plotKey(feature);
      //const selNo = this.selectedNo;
      const selNo = this.selectedId;
      const hit = (no == selNo)
      //console.log(`k:${no} sel:${selNo} hit:${hit}`)
      return hit;
    },
    plotLabel(k) {
      const layer = k.layer;
      const feature = k.feature;
      let result = '不明';
      if (layer == 'vectorLayer') {
        result = feature.get(this.plotDef.label);
        if (!result)
          result = feature.get(this.plotDef.key);
      }
      else if (layer == 'vectorLayerAlt') {
        result = feature.get(this.plotDefAlt.label);
        if (!result) {
          result = feature.get(this.plotDefAlt.key);
        }
      }
      return result ?? '';
    },
    setMessage () {
      if (this.targetPlot) {
        this.$store.commit('setMessage', '　');
      }
      else {
        let addrText = `${this.wardName} ${this.townName}`;
        if (this.oyaban > 0) {
          addrText += ` ${this.oyaban}`;
          if (this.edaban > 0) {
            addrText += `-${this.edaban}`;
          }
        }
        this.$store.commit('setMessage', `地図検索：${addrText}`);
      }
    },
    // 呼び出される事がない？
    onMapSelectionChanged (selection) {
      //this.features = selection;
      //this.existsGaiyo = false;
      dbglog(`onMapSelectionChanged(${selection})`, -1);
      if (selection.length == 1) {
        dbglog(`MapPane: onMapSelectionChanged(${selection[0]})`, -1);
        this.selectRow(selection[0]);
      }
    },
    /**
     * プロット一覧から特定の行を選択状態にする
     * @param { PlotData } target 選択状態にするプロットデータ
     */
    selectRow (target) {
      //test
      //this.targetPlotData = target.feature;
      //
      this.selectedLayer = target.layer;
      const selNo = this.plotKey(target);
      let selLabel = this.plotLabel(target);
      // 開発・造成・土石の堆積、指定道路用にSEQをselectedIdに保存
      //this.selectedNo = selNo;
      this.selectedId = selNo;
      this.selectedNo = selLabel;
      //開発・造成・土石の堆積の別を判定
      /*
      if (selNo != selLabel) {
        this.$store.commit('setSearchTargetType', selLabel.includes('規') ? 1 : 0);
      }
      */
      this.$store.commit('setSearchTargetType', target.layer == 'vectorLayerAlt' ? 1 : 0);
      // 選択された番号の概要書データが存在するか調べて
      // 閲覧ボタンの使用可否を設定する（建築のみ）
      this.searchGaiyo(this.selectedNo, (data) => {
        this.existsGaiyo = (data && data.length);
      });
    },
    selectNendo (nendo) {
      dbglog(` selected: id=${nendo.id}, pageNo=${nendo.pageNo}, branch=${nendo.branch}`);
      this.$store.commit('setIndexId', nendo.id);
      this.$store.commit('setNendoName', nendo.name);
      //プロット地図画面の入力値をクリア
      this.$store.commit('setSearchYear', 0);
      this.$store.commit('setSearchBango', '');
      //
      this.$router.push({ name: 'plot-map', params: { sheet: nendo.pageNo } });
    },
    /**
     * 現在選択されているプロットの概要書を表示する
     */
    browse () {
      this.$store.commit('setUkeNo', this.selectedNo);
      this.$store.commit('setGaiyoId', this.selectedId);
      this.$router.push({ name: 'loading', params: { action: 1 }});
    },
    /**
     * 指定された受付番号のデータを検索する
     * （リスト選択時に閲覧ボタン使用可否を決定するために呼び出される）
     * @param {String} ukeNo 受付番号
     */
    searchGaiyo (ukeNo, callback) {
      if (ukeNo == null || ukeNo.length == 0) {
        this.existsGaiyo = false; //暫定措置
        return;
      }
      this.existsGaiyo = true; //暫定措置

      let url;
      if (this.mode == 1) {
        url = gaiyoURL() + '?uke_no=' + ukeNo;
      }
      else if (this.mode == 2) {
        //url = elvUrl() +  '?uke_no=' + ukeNo;
        return;
      }
      else {
        return;
      }
      dbglog(url);

      fetch(url, {
        mode: 'cors',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(data);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.authDialog = true;
          return;
        }
        callback(data);
      })
      .catch((err) => {
        dbglog(`MapPane.vue.searchGaiyo(${ukeNo}): ${err}`);
      });
    },
    onScroll(event) {
      //console.log(event.target.scrollTop);
      if(event.target.scrollTop == 200){
        //console.log('in');
        document.getElementsByClassName('v-dialog__content')[0].style.height = '90%';
        document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
        document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
      }else if(event.target.scrollTop == 0){
        document.getElementsByClassName('v-dialog__content')[0].style.height = '30%';
        document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
        document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
      }
    },
    touchUp(){
      if(document.querySelector('.v-bottom-sheet') != null){
        document.querySelector('.v-bottom-sheet').style.height = '90%';
      }
    },
    touchDown(){
      if(document.querySelector('.v-bottom-sheet') != null){
        document.querySelector('.v-bottom-sheet').style.height = '30%';
      }
    },
    toggleButton(index) {
      this.$set(this.isPressed, index, !this.isPressed[index]);
    },
    checkBox(index) {
      this.$set(this.isCheckedBox, index, !this.isCheckedBox[index]);
    },
  }
}

</script>


<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";
body {
  background-color: #E0E0E0; /* グレーの背景色 */
  width: 600px;
}

.flex-container {
    display: flex;
    justify-content: flex-start; /* 左寄せに配置 */
    margin-bottom: 0px; /* セクションの下に余白を設定 */
  }

container {
  display: flex;
  flex-direction: column;
  max-width: 600px; /* 任意の横幅に設定 */
  margin: 0; /* 中央寄せを解除 */
  margin-bottom: 10px; /* セクションの下に余白を設定 */
  text-align: left; /* 左寄せに設定 */
  font-size: 14px;
}

container::after {
  content: '';
  display: block;
  border-bottom: 1px solid #ddd; /* 境界線のスタイルと色 */
  margin-top: 20px; /* 境界線とコンテンツの間の余白 */
}
.section {
  display: flex;
  flex-direction: row;
  padding: 3px;
  box-sizing: 100px ;
  margin-right: 10px; /* 各セクションの右側に余白を設定 */
}
.section > div {
  margin: auto 3px;
}


.content {
  display: flex;
}

.element {
  flex: 1;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px;
  box-sizing: border-box;
  margin: 5px;
}

.textbox {
  background-color: #ffffff; 
  width: auto; /* ボックスの幅 */
  height: 26px;
  padding: 10px; /* テキストとボックスの内側の余白 */
  border: 1px solid #808080; /* ボーダーのスタイルと色 */
  border-radius: 3px; /* 角の丸み */
  box-sizing: border-box; /* ボーダーとパディングをボックスの外側に含める */
  font-size: 14px; /* テキストのサイズ */
  margin-right: 5px;
}

.textbox:focus {
  border-color: #007bff; /* フォーカス時のボーダーの色 */
  outline: none; /* デフォルトのフォーカス時のアウトラインを無効にする */
}

.textbox[disabled] {
  background-color: #f0f0f0; /* ロックされているときの背景色 */
  color: #777; /* ロックされているときの文字色 */
  cursor: not-allowed; /* ロックされているときのカーソルスタイル */
}


.checkbox{
  margin-right: 5px;
}


thead {
  background-color: rgb(56, 110, 155);
  color: mintcream;
}
.split {
  //height: 100%;
  height: calc(100% - 12px);
  padding: 6px 0;
}
.right-box {
  right: 0;
  width: 30%;
  //height: 100%;
  height: calc(100% - 24px);
  margin: 4px 0;
  overflow-y: auto;
  background-color: rgb(118, 164, 170);
}
.acceptButton {
  font-size: 2rem;
  padding: 0.5em 1.5em;
}
/*
.selected {
  background-color: rgb(238, 255, 0);
}
*/


::v-deep .v-bottom-sheet {
  height: 30%;
}

.v-dialog__content {
  z-index:2 !important;
}

.win95-button {
  background-color: #C0C0C0;
  width: 150px;
  color: #000;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #808080; /* ボーダーのスタイルと色 */
  border-radius: 2px;
  position: relative;
  transition: all 0.3s ease;
}

.win95-button::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  background: rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  z-index: -1;
  transition: all 0.3s ease;
}
.win95-button.pressed {
  background-color: #B0B0B0;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4) inset, -1px -1px 2px rgba(255, 255, 255, 0.4) inset;
  color: #007bff; /* 右文字色青 */
}






select {
  width: 100%;
  padding: 4px; /* セレクトボックス内のコンテンツと枠の間に余白を作る */
  border: 1px solid #808080; /* ボーダーのスタイルと色 */
  background-color: white; /* セレクトボックスの背景色を白にする */
  cursor: pointer;
}

select[disabled] {
  background-color: #f0f0f0; /* ロックされているときの背景色 */
  color: #777; /* ロックされているときの文字色 */
  cursor: not-allowed; /* ロックされているときのカーソルスタイル */
}

.custom-select {
  display: inline-block;
  border: 1px solid #808080;
  border-radius: 1px;
  overflow: hidden;
  font-size: 12px;
  height: 24px; /* セレクトボックスの高さを指定 */
  position: relative; /* 相対位置指定を追加 */
  padding-right: 20px; /* 右側に余白を追加 */
}

.custom-select::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 4px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top-color: #555;
  transform: translateY(-50%);
  pointer-events: auto; /* pointer-events を有効にする */
  cursor: pointer; /* カーソルをポインターに変更する（任意） */
}

/* 操作部分 */
.button-container {
  display: flex;
  background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
  padding:3px;
  padding-bottom:3px;
  padding-right:3px;
}

.action-button {
  position: relative;
  background: linear-gradient(to bottom, #d1d1d1, #b0b0b0);
  color: #000000;
  border: 1px solid #808080; /* ボーダーのスタイルと色 */
  padding: 10px 15px;
  margin-right: 1px; /* 仕切りとの間隔 */
  margin-bottom: 0px; /* 下部の余白を解除 */
  cursor: pointer;
}

.action-button::after {
  content: "";
  position: absolute;
  top: 0;
  right: -2px; /* 仕切りの太さ */
  height: 100%;
  width: 2px; /* 仕切りの幅 */
  background-color: #7a7a7a; /* 仕切りの色 */
}

.action-button:hover {
  background-color: #7c7c7c; /* カーソルが乗った時の背景色 */
}
</style>
